/**
 * Shared module list used across:
 *   - Setup Wizard (Step 5 — Module Configuration)
 *   - Org Hierarchy Node Edit (site modules)
 */

export const MODULES = [
  { slug: 'safety',         label: 'Safety Management',       icon: '🦺' },
  { slug: 'hira',           label: 'HIRA / Risk Assessment',  icon: '⚠️' },
  { slug: 'ptw',            label: 'Permit to Work',          icon: '📋' },
  { slug: 'incidents',      label: 'Incident Management',     icon: '🚨' },
  { slug: 'capa',           label: 'CAPA',                    icon: '✅' },
  { slug: 'audits',         label: 'Audits',                  icon: '🔍' },
  { slug: 'training',       label: 'Training',                icon: '📚' },
  { slug: 'meetings',       label: 'Safety Meetings',         icon: '🗓️' },
  { slug: 'documents',      label: 'Document Control',        icon: '📄' },
  { slug: 'ssem',           label: 'SSEM',                    icon: '📊' },
  { slug: 'energy',         label: 'Energy & Resources (ERS)',icon: '⚡' },
  { slug: 'sustainability', label: 'Sustainability',          icon: '🌱' },
  { slug: 'board',          label: 'Board Governance',        icon: '🏛️' },
];
